import CartSource from "@/api/CartSource.js";

export const cartModule = {
    state: () => ({
        isLoader: null,
        comboCompanyModalIsShow: false,
        comboCompany: null,
        products: [],
        removed_stop_list: [],
        total: 0,
        isInitialized: false
    }),
    mutations: {
        setProducts(state, data) {
            state.products = [...data];
        },
        setTotal(state, data) {
            state.total = data;
        },
        SET_INITIALIZED_FLAG(state, data) {
            state.isInitialized = data;
        }
    },
    getters: {
        getProduct: (state) => (product_id) => {
            return state.products.find(cart => cart.product.product_id === product_id)
        },
        getAlProductInCart: (state) => (product_id) => {
            return state.products.filter(cart => cart.product.product_id === product_id)
        }
    },
    actions: {
        async setCart({ state, commit, dispatch }, promise) {
            await promise.then(async (response) => {
            await commit('setProducts', response.products)
            state.removed_stop_list = response.removed_stop_list
            state.comboCompany = response?.comboCompany ?? null

            await commit('setTotal', response.total);
            dispatch('shipping/setShipping', response.shipping_selected, { root: true })
            dispatch('coupon/setCoupon', response.coupon?.code ?? null, { root: true })
            console.log(': ', response.reward);
            dispatch('reward/setReward', response.reward, { root: true })
            return Promise.resolve();
        }).catch(error => {
            commit('setProducts', []);
            return Promise.reject(error);
        }).finally(() => {
            state.isLoading = false;
            commit('SET_INITIALIZED_FLAG', true);
        })
        },

        async load({ state, dispatch }) {
            try {
                state.isLoading = true;
                await dispatch('setCart', this.$API.manager.getSource(CartSource).list())
            } finally {
                state.isLoading = false;
            }
        },

        async add({state, rootState, dispatch}, {product_id, options = []}) {

            if(rootState.shipping.shipping === null){
                rootState.shipping.showModal = true;
                this.$toast.open({
                    message: 'Выберите способ получения заказа, чтобы добавить товар в корзину',
                    type: 'default',
                });
                return;
            }
            try {
                state.isLoading = true;
                await dispatch('setCart', this.$API.manager.getSource(CartSource).add(product_id, ...options))
                this.$toast.open({
                    message: 'Блюдо успешно добавлено в корзину',
                    type: 'success',
                });
                return Promise.resolve();
            } catch (error) {
                return Promise.reject(error);
            }
            finally {
                state.isLoading = false;
            }
        },
        async update({state, commit, dispatch}, {cart_id, quantity}) {
            try {
                state.isLoading = true;
                await dispatch('setCart', this.$API.manager.getSource(CartSource).update(cart_id, quantity))
            } finally {
                state.isLoading = false;
            }
        },
        async remove({state, commit, dispatch}, cart_id) {
            try {
                state.isLoading = true;
                await dispatch('setCart', this.$API.manager.getSource(CartSource).remove(cart_id))
            } finally {
                state.isLoading = false;
            }
        },
        async removeAll({state, dispatch}) {
            try {
                state.isLoading = true;
                await dispatch('setCart', this.$API.manager.getSource(CartSource).removeAll())
            } finally {
                state.isLoading = false;
            }
        }
    },
    namespaced: true
}
